import { colors } from "../../Styles";

export function FilterParameter({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M104.84,221.86v-58.25c0-1.04-.35-2.06-.98-2.88L29.34,64.48c-2.39-3.09-.19-7.59,3.72-7.59h217.34c3.91,0,6.11,4.49,3.72,7.59l-74.52,96.25c-.64.82-.98,1.84-.98,2.88v58.25c0,2.6-2.11,4.71-4.71,4.71h-64.37c-2.6,0-4.71-2.11-4.71-4.71Z"/>
    </svg>
  );
}
